export default __webpack_public_path__ + "static/layout-image-1-f634373168e3f426b99f61d8239329bd.jpg";